import React, { useState } from "react";
import { Input } from "antd";

const { TextArea } = Input;

const MaterialLikeTextArea = ({ label, value, onChange, readOnly, required, rows = 4, placeholder = '' }) => {
  const [focused, setFocused] = useState(false);
  const shouldFloat = focused || value || placeholder;

  return (
    <div className={`mui-input-container ${shouldFloat ? "focused" : ""}`}>
      <label className="mui-label">
        {/* {(focused || value) && required && <span className="required-star">*</span>} */}
        {required && <span className="required-star">*</span>}{label}
      </label>
      <TextArea
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        className="mui-input"
        bordered={false}
        readOnly={readOnly}
        rows={rows}
        autoSize={{ minRows: rows, maxRows: 6 }}
      />
      <span className="mui-underline" />
    </div>
  );
};

export default MaterialLikeTextArea;
